<template>
  <svg
    version="1.1"
    id="linkedin"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 128 128"
    style="enable-background:new 0 0 128 128;"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M109,11.1H18.7c-4.3,0-7.9,3.4-7.9,7.6v90.6c0,4.2,2.4,7.6,6.8,7.6h90.1c4.4,0,8.9-3.4,8.9-7.6V18.7
		C116.6,14.5,113.2,11.1,109,11.1"
      />
      <path
        class="st1"
        d="M117,2.1H11.4c-5,0-9.3,4-9.3,8.9v106c0,4.9,2.8,8.9,7.9,8.9h105.5c5.1,0,10.4-4,10.4-8.9V11
		C125.9,6.1,122,2.1,117,2.1z M49.3,49.3H66v8.5h0.2c2.5-4.6,10-9.2,19.3-9.2c17.8,0,22.8,9.5,22.8,27v32.7H90.5V78.7
		C90.5,70.9,87.4,64,80,64c-8.9,0-13.1,6-13.1,15.9v28.3H49.3V49.3z M19.8,108.2h17.7v-59H19.8V108.2z M39.7,28.6
		c0,6.1-4.9,11.1-11.1,11.1s-11.1-4.9-11.1-11.1s4.9-11.1,11.1-11.1S39.7,22.5,39.7,28.6z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    render() {
      return null
    }
  }
</script>

<style lang="scss" scoped>
  svg {
    vertical-align: bottom;
    height: 2rem;
    width: 2rem;
  }
  .st0 {
    fill: white;
  }
  .st1 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: #2867b2;
    transition: 0.25s ease-out;
  }
  svg:hover .st1 {
    fill-rule: evenodd;
    clip-rule: evenodd;
    fill: scale-color($color: #2867b2, $lightness: 12%);
  }
</style>
